export default __webpack_public_path__ + "static/media/ButterflyPage2.87413fdf.txt";